import { render, staticRenderFns } from "./bidOpeningDetail.vue?vue&type=template&id=0a9e95a2&"
import script from "./bidOpeningDetail.vue?vue&type=script&lang=js&"
export * from "./bidOpeningDetail.vue?vue&type=script&lang=js&"
import style0 from "./bidOpeningDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports